import { render, staticRenderFns } from "./EventosPasados.vue?vue&type=template&id=087ace5a&scoped=true"
import script from "./EventosPasados.vue?vue&type=script&lang=js"
export * from "./EventosPasados.vue?vue&type=script&lang=js"
import style0 from "./EventosPasados.vue?vue&type=style&index=0&id=087ace5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ace5a",
  null
  
)

export default component.exports